<template>
  <div style='word-wrap:break-word'>
    <div class=WordSection1>

    <p class=MsoNormal align=center style='text-align:center'><b><span
    style='font-size:14.0pt;font-family:"Calibri",sans-serif'>CORCENTRIC USER TERMS
    OF SERVICE</span></b></p>

    <p class=MsoNormal align=center style='text-align:center'><b><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif;color:#343434'>Welcome
    to Corcentric. Please read all of the rights and restrictions set forth in these
    Corcentric User Terms of Service (the “<u>User Terms</u>”). These User Terms are
    a legally binding agreement between Corcentric, LLC “<u>Corcentric</u>”, “<u>we”</u>,
    “<u>us</u>” and “you” as the “User” and </span><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>set forth the terms and conditions that
    govern your use and/or access of Corcentric’s online services platforms,
    including:</span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><b><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>Corcentric Platform,
    CorConnect, Fleet Solutions, COR360, EIPP, Netsend, PO-Driven Enrollment, SmartSource
    9.X, SmartSource Cloud, SmartContracts, SmartAnalytics, eAccess, iSupport (the
    “<u>Software Services</u>”)</span></b><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>. </span></b></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><b><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>By accessing the
    Software Services, you agree to be bound by the terms and conditions of these
    User Terms. </span></p>

    <p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></p>

    <p class=MsoListParagraphCxSpFirst style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Commercial
    Agreement.</span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>1.1<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    text-transform:uppercase'>You represent to Corcentric that YOU have been
    granted rights to access and use the Software Services by a Customer, as an
    authorized user. A Customer is an entity who has entered into an </span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>ORDER, SUBSCRIPTION
    AGREEMENT, TRIAL AGREEMENT, OR OTHER BINDING COMMERCIAL AGREEMENT (EACH A “<u>COMMERCIAL
    AGREEMENT</u>”) WITH CORCENTRIC IN CONNECTION WITH THE RIGHT TO USE THE
    SOFTWARE SERVICES. USE OF THE SOFTWARE SERVICES IS SUBJECT TO THE TERMS AND
    CONDITIONS WHICH ARE SPECIFIED UNDER THE COMMERCIAL AGREEMENT. THE TERMS AND
    CONDITIONS OF THE COMMERCIAL AGREEMENT ARE INCORPORATED BY REFERENCE INTO THESE
    USER TERMS, AND IN THE EVENT OF CONFLICT BETWEEN THE COMMERCIAL AGREEMENT AND
    THESE USER TERMS, THE COMMERCIAL AGREEMENT SHALL CONTROL. </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>1.2<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>IF
    YOU HAVE REGISTERED FOR A TRIAL, CORCENTRIC WILL MAKE THE SOFTWARE SERVICES
    AVAILABLE TO YOU ON A TRIAL BASIS UNTIL THE EARLIER OF (A) THE END OF THE TRIAL
    PERIOD, OR (B) THE START DATE OF ANY PURCHASED SUBSCRIPTION PERIOD.   </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Rights
    Granted &amp; Ownership.</span></b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>  </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>2.1<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>For
    the duration of the Commercial Agreement, Corcentric grants to you a
    non-exclusive, non-transferable, worldwide, limited right to access and use the
    Software Services solely for the permitted uses under the Commercial
    Agreement.          </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>2.2<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>The
    Software Services are proprietary to Corcentric. Corcentric hereby retains all
    right, title and interest in and to the Software Services, the documentation
    and associated intellectual property rights, and User acknowledges that it
    neither owns nor acquires any intellectual property rights or license to use
    the Software Services in excess of the scope and/or duration of the Software
    Services stated in the Commercial Agreement. </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Account
    Registration &amp; Your Data. </span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>3.1<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'> </span></b><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>In order to access
    the Software Services, you or Customer must register you to create an account. </span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You agree to provide
    true, accurate, current and complete information about yourself as prompted by
    the registration and log in process (such information being your “<u>Account
    Information</u>”) and promptly update any such information so that it remains
    current. You may receive a unique username and password in connection with your
    account (collectively referred to herein as your “<u>Username</u>”). User
    agrees not to allow any other person to use User’s Username and/or password to
    access or use the Software Services under any circumstances. You are solely and
    entirely responsible for maintaining the confidentiality of your Username and
    password.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>3.2<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You
    agree and acknowledge that Customer is responsible for managing your access and
    use of the Software Services as an authorized User. Customer may modify and
    re-assign access and rights you may have within the Software Services.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>3.3<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>As
    part of your use of the Software Services, you may submit and upload data,
    documents, information and/or content to the Software Services (“<u>Your Data</u>”).
    </span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You
    acknowledge that as between Corcentric and Customer, Your Data is owned by
    Customer and that Corcentric and Customer may use Your Data through their use
    and provision, as applicable, of the Software Services. </span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You shall have sole
    responsibility for the accuracy, quality, integrity, legality, reliability, </span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>and </span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>appropriateness of
    all of Your Data.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>3.4<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You
    acknowledge and agree that any questions, comments, suggestions, ideas,
    feedback or other information about the Software Services (“<u>Submissions</u>”)
    provided by you to Corcentric are non-confidential and hereby grant to
    Corcentric an non-exclusive, royalty-free, fully paid-up, assignable,
    transferable, sublicensable, perpetual, irrevocable worldwide right and license
    to use and exploit such Submissions. You hereby assign to Corcentric all
    exclusive rights, including all intellectual property rights, to Submissions
    and Corcentric shall be entitled to the unrestricted use and dissemination of
    these Submissions for any purpose, commercial or otherwise, without notice,
    attribution or compensation to you.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>3.5<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>AS
    BETWEEN CORCENTRIC AND CUSTOMER, IT IS SOLELY CUSTOMER’S RESPONSIBILITY TO (A)
    INFORM YOU OF ANY RELEVANT CUSTOMER POLICIES AND PRACTICES AND ANY SETTINGS
    THAT MAY IMPACT THE PROCESSING OF YOUR DATA; (B) ENSURE THAT THE TRANSFER AND
    PROCESSING OF YOUR DATA UNDER THE COMMERCIAL AGREEMENT IS LAWFUL; (C) OBTAIN
    ANY RIGHTS, PERMISSIONS OR CONSENTS FROM YOU THAT ARE NECESSARY FOR THE LAWFUL
    USE OF YOUR DATA; AND (D) RESPOND TO AND RESOLVE ANY DISPUTE WITH YOU RELATING
    TO OR BASED ON YOUR DATA, THE SERVICES OR CUSTOMER’S FAILURE TO FULFILL THESE
    OBLIGATIONS. </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpLast style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Restrictions.
    </span></b></p>

    <p style='margin:0in; margin-bottom: .2in; text-indent:0in;page-break-after:auto'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif;'>4.1<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You shall not engage
    in any act or omission that would impair Corcentric’s intellectual property
    rights in the Software Services and any other materials, information, processes or subject matter proprietary to
    Corcentric.</span></p>

    <p style='margin:0in;text-indent:0in;page-break-after:auto'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif;'>4.2<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif;'>You may
    not and may not cause or permit others to:</span></p>

    <p style='margin-top:0in;margin-right:0in;margin-bottom:.2in;margin-left:.5in;
    text-indent:-.25in;page-break-after:auto'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif;'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>Remove or modify any program markings or any notice of
    Corcentric’s or its licensors’ proprietary rights;</span></p>

    <p style='margin-top:0in;margin-right:0in;margin-bottom:.2in;margin-left:.5in;
    text-indent:-.25in;page-break-after:auto'><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif;'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>Make the programs or materials from the Software Services
    available in any manner to any third party for use in the third party’s business
    operations; </span></p>

    <p class=MsoBodyText style='margin: 0in 0in .2in 0.5in; text-indent: -0.25in; break-after: auto;'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>Modify or make derivative works of, disassemble, decompile,
    reverse engineer, reproduce, distribute, republish or download any part of the
    Software Services, or access or use the Software Services in order to build or
    support, and/or assist a third party in building or supporting, products or services
    competitive to Corcentric;</span></p>

    <p class=MsoBodyText style='margin: 0in 0in .2in 0.5in; text-indent: -0.25in; break-after: auto;'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>License, sublicense, sell, resell, transfer, assign, distribute or
    otherwise commercially exploit or make available to any third party the
    Software Services or Corcentric materials or Documentation in any way.</span></p>

    <p class=MsoBodyText style='margin: 0in 0in .2in 0.5in; text-indent: -0.25in; break-after: auto;'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>e.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>Use the Software Services other than in accordance with the
    Documentation available for each Software Service. “<u>Documentation</u>” means
    all standards, reference materials, system requirements, and other similar
    information and materials the describe the functionality and operability of the
    Software Services, which may be updated amended, or replaced by Corcentric from
    time to time.   </span></p>

    <p class=MsoBodyText style='margin: 0in 0in .2in 0.5in; text-indent: -0.25in; break-after: auto;'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>f.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif;
    '>Authorize any other third party to access or use the Software
    Services through your account or otherwise share your account with any other
    party. </span></p>

    <p style='margin:0in;text-indent:0in;page-break-after:auto'><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif;'>4.3<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>Y</span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>ou shall not use or
    permit use of the Software Services for any purpose that may (a) menace or
    harass any person or cause damage or injury to any person or property, (b)
    involve the publication of any material that is false, defamatory, harassing or
    obscene, (c) violate privacy rights or promote bigotry, racism, hatred or harm,
    (d) constitute unsolicited bulk e-mail, “junk mail”, “spam” or chain letters;
    (e) constitute an infringement of intellectual property or other proprietary
    rights, or (f) otherwise violate applicable laws, ordinances or regulations. In
    addition to any other rights afforded to Corcentric under these User Terms,
    Corcentric reserves the right to take remedial action if any material violates
    the restrictions in the foregoing sentence, including the removal or
    disablement of access to such material. Corcentric shall have no liability to
    you in the event that Corcentric takes such action. </span></p>

    <p class=MsoListParagraphCxSpFirst style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;
    '>Updates to the Software Services. </span></b><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif;'>You agree
    and acknowledge </span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>Corcentric
    </span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>may make
    changes or updates to the Software Services (such as infrastructure, security,
    technical configurations, application features, etc.) during the Term,
    including to reflect changes in technology, industry practices, patterns of
    system use, and availability of Third Party Content.  “<u>Third Party Content</u>”
    means all text, files, images, graphics, illustrations, information, data,
    audio, video, photographs and other content and material, in any format, that
    are obtained or derived from third party sources outside of Corcentric and made
    available to you through, within, or in conjunction with your use of the
    Software Services. </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Term
    and Termination. </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>The
    Term of these User Terms shall begin on the date that you begin to access
    and/or use the Software Services until terminated pursuant to these User Terms
    (the “<u>Term</u>”). Corcentric may terminate these User Terms or suspend your
    access immediately if you fail to comply with any provision of this these User
    Terms. In the event of termination of these User Terms, all rights granted
    hereunder shall immediately expire and </span><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>you shall no longer have rights to access or
    use the Software Services.  </span><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>Provisions that survive termination or expiration of
    these User Terms are those relating to limitation of liability,
    Indemnification, and others which by their nature are intended to survive. </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpLast style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Confidentiality.
    </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>In
    its provision of the Software Services to you, Corcentric may disclose to you
    certain information that is confidential to Corcentric, including, but not
    limited to any data or information in any form disclosed by Corcentric to</span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'> you by any means
    (the “<u>Confidential Information</u>”). You agree not to disclose the
    Confidential Information to any third party other than as set forth herein for
    a period of three years from the date of the disclosure of the Confidential
    Information to you.  You</span><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>
    will not use the Confidential Information except (i) as necessary to perform
    your duties under these User Terms; and (ii) in any other manner that these
    User Terms expressly authorizes.  Your duties under this section will apply to
    (i) information which is marked to clearly identify it as the Corcentric’s
    Confidential Information, or, if disclosed orally, which is identified as
    Confidential Information both at the time of disclosure; and (ii) information
    which, due to its nature or the circumstances surrounding its disclosure, any
    reasonable person would conclude is intended to be considered confidential and
    proprietary for purposes of these User Terms.</span></p>

    <p class=MsoNormal><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraph style='margin-left:0in;text-align:justify;text-justify:
    inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif; font-weight: 600;'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Mobile
    Services. </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>The
    Software Services may be available via mobile phone and may provide without
    limitation the ability to upload content and to send and receive messages,
    instant messages, and other types of communications that may be developed for
    the Software Services (collectively the “<u>Mobile Services</u>”). Your mobile
    carrier’s normal rules, regulations messaging, data and other rates and fees
    may apply when using the Mobile Services. In addition, downloading, installing,
    or using certain Mobile Services may be prohibited or restricted by your mobile
    carrier, and not all Mobile Services may work with all mobile carriers or
    devices.</span></p>

    <p class=MsoNormal><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraph style='margin-left:0in;text-align:justify;text-justify:
    inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif; font-weight: 600;'>9.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'> Disclaimer
    of Warranty. </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>THE
    SOFTWARE SERVICES ARE PROVIDED “AS IS” AND EXCEPT AS OTHER PROVIDED HEREIN,
    CORCENTRIC EXPRESSLY DISCLAIMS, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE
    LAW, ANY AND ALL OTHER PROMISES, REPRESENTATIONS AND WARRANTIES OF ANY KIND OR
    NATURE, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO,
    ANY WARRANTIES OF QUALITY, VALUE, OPERABILITY, CONDITION, MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE, DATA ACCURACY, SYSTEM INTEGRATION,
    WORKMANSHIP, SUITABILITY, NON-INFRINGEMENT, AND/OR THE ABSENCE OF DEFECTS
    THEREIN, WHETHER LATENT OR PATENT.  YOU ACKNOWLEDGE THAT CORCENTRIC'S
    OBLIGATIONS UNDER THESE USER TERMS ARE FOR THE BENEFIT OF YOU ONLY.</span></p>

    <p class=MsoNormal><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpFirst style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Limitation
    of Liability.</span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>
    IN NO EVENT SHALL CORCENTRIC BE LIABLE FOR ANY INCIDENTAL, INDIRECT, SPECIAL,
    CONSEQUENTIAL OR PUNITIVE DAMAGES, REGARDLESS OF THE NATURE OF THE CLAIM,
    INCLUDING, WITHOUT LIMITATION, LOST PROFITS, COSTS OF DELAY, ANY FAILURE OF
    DELIVERY, BUSINESS INTERRUPTION, COSTS OF LOST OR DAMAGED DATA OR DOCUMENTATION
    OR LIABILITIES TO THIRD PARTIES ARISING FROM ANY SOURCE, EVEN IF SUCH PARTY HAS
    BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.  THIS LIMITATION UPON DAMAGES
    AND CLAIMS IS INTENDED TO APPLY WITHOUT REGARD TO WHETHER OTHER PROVISIONS OF
    THESE USER TERMS HAVE BEEN BREACHED OR HAVE PROVEN INEFFECTIVE.  THE CUMULATIVE
    LIABILITY OF CORCENTRIC TO USER FOR ALL CLAIMS ARISING FROM OR RELATING TO
    THESE USER TERMS, INCLUDING, WITHOUT LIMITATION, ANY CAUSE OF ACTION SOUNDING
    IN CONTRACT, TORT, OR STRICT LIABILITY, SHALL NOT EXCEED FIFTY DOLLARS (U.S.
    $50.00) IN THE AGGREGATE.  THIS LIMITATION OF LIABILITY IS INTENDED TO APPLY
    WITHOUT REGARD TO WHETHER OTHER PROVISIONS OF THESE USER TERMS HAVE BEEN
    BREACHED OR HAVE PROVEN INEFFECTIVE.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>11.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Privacy.
    </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>Please
    review our </span><a href="https://www.corcentric.com/privacy-policy/"><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>Privacy Policy</span></a><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'> for information on
    how collect, use, process, and transfer data related to your use of the
    Services. </span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>12.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Export.
    </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>Export
    laws and regulations of the United States and any other relevant local export
    laws and regulations may apply to the Software Services. You agree that such
    export laws govern your use of the Software Services (including technical data)
    and any deliverables provided under these User Terms.  You agree to comply with
    all such export laws and regulations (including “deemed export” and “deemed
    re-export” regulations).</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>13.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Severability.
    </span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>If
    any provision of these User Terms is invalid or unenforceable for any reason,
    such provision shall be construed to have been adjusted to the minimum extent
    necessary to cure such invalidity or unenforceability.  The invalidity or
    unenforceability of one or more of the provisions contained in these User Terms
    shall not have the effect of rendering any such provision invalid or
    unenforceable in any other case, circumstance or jurisdiction, or of rendering
    any other provisions of these User Terms invalid or unenforceable whatsoever.</span></p>

    <p class=MsoListParagraphCxSpMiddle><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpLast style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>14.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Government
    Use.</span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>
    The Corcentric Software is a &quot;commercial item,&quot; as that term is
    defined at 48 C.F.R. 2.101 (OCT 1995), consisting of &quot;commercial computer
    software&quot; and &quot;commercial computer software documentation,&quot; as
    such terms are used in 48 C.F.R. 12.212 (SEPT 1995) and is provided to the U.S.
    Government only as a commercial end item. Consistent with 48 C.F.R. 12.212 and
    48 C.F.R. 227.7202-1 through 227.7202-4 (JUNE 1995), all U.S. Government Users
    and end users acquire the Corcentric Software with only those rights set forth
    herein.</span></p>

    <p class=MsoNormal><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpFirst style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>15.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Controlling
    Law and Complete Agreement.</span></b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'> These User Terms shall be construed and interpreted
    under the laws of the State of Delaware, without regard to the conflict of laws
    principals thereof or to the United Nations Convention for the International
    Sale of Goods. If any provision of these User Terms, or portion thereof, is
    found to be unenforceable, such provision shall be enforced to the maximum
    extent possible and the remainder of this these User Terms shall continue in
    full force and effect.</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph'><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>&nbsp;</span></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>16.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Assignment</span></b><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>. </span><span
    style='font-size:10.0pt;font-family:"Calibri",sans-serif'>You may not assign
    these User Terms or give or transfer the Software Services or an interest in
    them to another individual or entity.</span></p>

    <p class=MsoListParagraphCxSpMiddle><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpMiddle style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>17.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Modifications
    to these Terms of Use. </span></b><span style='font-size:10.0pt;font-family:
    "Calibri",sans-serif'>Corcentric may modify and update these User Terms from
    time to time. You can review the most current version of the User Terms at any
    time by visiting this page. All changes will become effective on the date we
    publish such change. Your continued use of the Software Services after the
    effective date of any changes shall constitute your acceptance of the revised
    User Terms.  </span></p>

    <p class=MsoListParagraphCxSpMiddle><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif'>&nbsp;</span></b></p>

    <p class=MsoListParagraphCxSpLast style='margin-left:0in;text-align:justify;
    text-justify:inter-ideograph;text-indent:0in'><b><span style='font-size:10.0pt;
    font-family:"Calibri",sans-serif; font-weight: 600;'>18.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
    </span></span></b><b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif; font-weight: 600;'>Entire
    Agreement</span></b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'>.
    You agree that these User Terms and the information which is incorporated into these
    User Terms by written reference, together with the Commercial Agreement, if
    applicable, is the complete agreement for the Software Services and supersedes
    all prior or contemporaneous agreements or representations, written or oral,
    regarding such Software Services.</span></p>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CorcentricPrivacyPolicy'
}
</script>

<style scoped>

</style>
